import { lazy } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import InterviewResultPage from 'src/pages/dashboard/interview/result';
import InterviewEditPage from 'src/pages/dashboard/interview/edit';
import InterviewCreatePage from 'src/pages/dashboard/interview/new';
import JobCreatePage from 'src/pages/dashboard/job/new';
import ChangePassword from 'src/pages/dashboard/change-password';
import OrganizationSettings from 'src/sections/account/organization-settings';
import ManageAccount from 'src/pages/dashboard/user/manage-account';
import { ReportsListView } from 'src/sections/reports/view';
import CandidateListPage from 'src/pages/dashboard/candidates/list';
import JobEditPage from 'src/pages/dashboard/job/edit';
import AddCandidate from 'src/pages/dashboard/candidates/add-candidate';
import EditCandidate from 'src/pages/dashboard/candidates/edit-candidate';
import CandidateDetails from 'src/pages/dashboard/candidates/candidate-details';
import JobCandidateDetailsView from 'src/sections/job-candidate/view/job-candidate-view';
import JobDetailsPage from 'src/pages/dashboard/job/details';
import JobCreationProvider from 'src/sections/job2/context/job-creation-provider';
import JobCreationConsumer from 'src/sections/job2/context/job-creation-consumer';
import AddJobCandidatePage from 'src/pages/dashboard/job-candidate/add';
import MessagePage from 'src/pages/dashboard/message/message';
import OrganizationPage from 'src/pages/dashboard/settings/organization';
import TeamsPage from 'src/pages/dashboard/settings/teams';
import WorkflowAutomationPage from 'src/pages/dashboard/settings/workflow-automation';
import NotificationPage from 'src/pages/dashboard/settings/notification';

const JobListPage = lazy(() => import('src/pages/dashboard/job/list'));

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Outlet />
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <Navigate to="jobs" />, index: true },
      {
        path: 'jobs',
        children: [
          { element: <JobListPage />, index: true },
          {
            path: ':id',
            children: [
              {
                path: 'edit',
                element: (
                  <JobCreationProvider>
                    <JobCreationConsumer>
                      <JobEditPage />
                    </JobCreationConsumer>
                  </JobCreationProvider>
                ),
              },
              {
                path: 'candidates',
                children: [
                  {
                    element: <JobDetailsPage />,
                    index: true,
                  },
                  {
                    path: 'add',
                    element: <AddJobCandidatePage />,
                  },
                ],
              },
            ],
          },
          {
            path: 'new',
            element: (
              <JobCreationProvider>
                <JobCreationConsumer>
                  <JobCreatePage />
                </JobCreationConsumer>
              </JobCreationProvider>
            ),
          },

          { path: 'edit/:id', element: <JobEditPage /> },
          {
            path: ':jobId/interview/:interviewId/result',
            element: <InterviewResultPage />,
          },
          {
            path: ':jobId/candidates/:candidateId',
            element: <JobCandidateDetailsView />,
          },
          { path: ':jobId/interview/new', element: <InterviewCreatePage /> },
        ],
      },
      {
        path: 'candidates',
        children: [
          { element: <CandidateListPage />, index: true },
          { path: ':candidateId', element: <CandidateDetails /> },
          { path: 'new', element: <AddCandidate /> },
          { path: 'edit/:candidateId', element: <EditCandidate /> },
        ],
      },
      {
        path: 'message',
        children: [{ element: <MessagePage />, index: true }],
      },
      { path: 'reports', element: <ReportsListView />, index: true },
      {
        path: 'settings',
        children: [
          { element: <Navigate to="organization" />, index: true },
          { path: 'organization', element: <OrganizationPage /> },
          { path: 'teams', element: <TeamsPage /> },
          { path: 'workflow-automation', element: <WorkflowAutomationPage /> },
          { path: 'notification', element: <NotificationPage /> },
        ],
      },
      {
        path: 'manage-account',
        children: [{ element: <ManageAccount />, index: true }],
      },
      {
        path: 'interview',
        children: [{ path: ':id/edit', element: <InterviewEditPage /> }],
      },
      {
        path: 'change-password',
        children: [{ element: <ChangePassword />, index: true }],
      },
      {
        path: 'organization-settings',
        children: [{ element: <OrganizationSettings />, index: true }],
      },
    ],
  },
];
